export default __webpack_public_path__ + "static/media/pre-year-question-paper.7ab6615e.svg";